import React from 'react';

import { BoxProps, Button, ButtonProps, GridProps } from '@mui/material';
import { FieldProp, FormBuilder } from 'app/modules/form-builder-lib';
import { useFormStepperAutoSubmit } from './hooks/useFormStepperAutoSubmit';
import { useFormStepper } from './hooks/useFormStepper';
import { UseFormWatch } from 'react-hook-form';
import { translate } from 'react-jhipster';

const defaultButtonProps: ButtonProps = { variant: 'contained', color: 'primary', size: 'small' };
const defaultContainerProps: GridProps = { my: 1, spacing: 2, width: '60%', mx: 'auto' };
const defaultBoxProps: BoxProps = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  mt: 1,
};

interface FormStepperProps {
  fields: FieldProp[] | ((watch: UseFormWatch<any>) => FieldProp[]);
  autoSubmit?: boolean;
  defaultValues?: any;
  values?: any;
  submitFormText?: null | string;
  formButtons?: null | (({ children }: { children: any }) => JSX.Element);
  onSubmit: (data: any) => void;
  onChange?: null | ((data: any) => void);
  containerProps?: GridProps;
  buttonProps?: ButtonProps;
  boxProps?: BoxProps;
}

export const FormStepper = ({
  fields,
  onSubmit,
  onChange = null,
  autoSubmit = false,
  defaultValues = null,
  values = null,
  formButtons = null,
  submitFormText = translate('stepper.next', null, 'Next'),
  containerProps = {},
  buttonProps = {},
  boxProps = defaultBoxProps,
}: FormStepperProps) => {
  const { methods, fields: formFields, FormButtons } = useFormStepper({ formButtons, defaultValues, values, fields });

  // only applicable when autoSubmit is true
  useFormStepperAutoSubmit(autoSubmit, methods.watch, () => {
    methods.handleSubmit(onChange)();
  });

  return (
    <FormBuilder
      fields={formFields}
      methods={methods}
      containerProps={{ ...defaultContainerProps, ...containerProps }}
      boxProps={boxProps}
    >
      <FormButtons>
        <Button
          {...defaultButtonProps}
          {...buttonProps}
          onClick={() => {
            methods.handleSubmit(onSubmit)();
          }}
        >
          {submitFormText}
        </Button>
      </FormButtons>
    </FormBuilder>
  );
};
